export default {
    SET_CANVAS_SIZE: "SET_CANVAS_SIZE",
    REMOVE_BASE_IMAGE: "REMOVE_BASE_IMAGE",
    SET_BASE_IMAGE: "SET_BASE_IMAGE",
    HIDE_OVERLAY: "HIDE_OVERLAY",
    SHOW_OVERLAY: "SHOW_OVERLAY",
    SET_CANVAS: "SET_CANVAS",

}